export const MOBILE_FOOTER_LEGAL = 'MOBILE_FOOTER_LEGAL';
export const SIDE_MENU_PRIVACY_RESPONSIBLE_GAMING = 'SIDE_MENU_RESPONSIBLE_GAMING';
export const MOBILE_HELP_PAGE_SUBMENU_TERMS = 'MOBILE_HELP_PAGE_SUBMENU_TERMS';
export const MOBILE_MAIN_MENU_CASINO = 'MOBILE_MAIN_MENU_CASINO';
export const MOBILE_MAIN_MENU_SPORTS = 'MOBILE_MAIN_MENU_SPORTS';
export const SIDE_MENU_PRIVACY_POLICY = 'SIDE_MENU_PRIVACY_POLICY';
export const SIDE_MENU_COMPLAINT_PROCEDURE = 'SIDE_MENU_COMPLAINT_PROCEDURE';
export const SIDE_MENU_PROMOTIONS = 'SIDE_MENU_PROMOTIONS';
export const RESPONSIVE_FOOTER_AFFILIATE = 'RESPONSIVE_FOOTER_AFFILIATE';
export const RESPONSIVE_FOOTER_TEXT = 'RESPONSIVE_FOOTER_TEXT';
export const RESPONSIVE_FOOTER_BLOG_TEXT = 'RESPONSIVE_FOOTER_BLOG_TEXT';
export const RESPONSIVE_FOOTER_BLOG_LINK = 'RESPONSIVE_FOOTER_BLOG_LINK';
export const P_FOOTER_PAGE_CASINO = 'P_FOOTER_PAGE_CASINO';
export const P_FOOTER_PAGE_SPORTSBOOK = 'P_FOOTER_PAGE_SPORTSBOOK';
export const SIDE_MENU_WHY = 'SIDE_MENU_WHY';
export const MOBILE_HELP_PAGE_SUBHEADER_ABOUT = 'MOBILE_HELP_PAGE_SUBHEADER_ABOUT';

export const MOBILE_LANDINGPAGE_AFFILIATE_LINK = 'MOBILE_LANDINGPAGE_AFFILIATE_LINK';
export const FOOTER_TWITTER_URL = 'FOOTER_TWITTER_URL';
export const FOOTER_YOUTUBE_URL = 'FOOTER_YOUTUBE_URL';
export const FOOTER_FACEBOOK_URL = 'FOOTER_FACEBOOK_URL';
export const FOOTER_INSTAGRAM_URL = 'FOOTER_INSTAGRAM_URL';
export const FOOTER_HALLESCHER_LOGO = 'FOOTER_HALLESCHER_LOGO';
export const FOOTER_WEHEN_WIESBADEN = 'FOOTER_WEHEN_WIESBADEN';

export const FOOTER_INDIA_TWITTER_URL = 'FOOTER_INDIA_TWITTER_URL';
export const FOOTER_INDIA_TELEGRAM_URL = 'FOOTER_INDIA_TELEGRAM_URL';
export const FOOTER_INDIA_FACEBOOK_URL = 'FOOTER_INDIA_FACEBOOK_URL';
export const FOOTER_INDIA_INSTAGRAM_URL = 'FOOTER_INDIA_INSTAGRAM_URL';

export const FOOTER_INSTAGRAM = 'FOOTER_INSTAGRAM';
export const FOOTER_YOUTUBE = 'FOOTER_YOUTUBE';
export const FOOTER_TWITTER = 'FOOTER_TWITTER';
export const FOOTER_FACEBOOK = 'FOOTER_FACEBOOK';

export const FOOTER_FIRST_PART_TEXT = 'FOOTER_FIRST_PART_TEXT';
export const FOOTER_FIRST_LINK_TEXT = 'FOOTER_FIRST_LINK_TEXT';
export const FOOTER_FIRST_LINK_URL = 'FOOTER_FIRST_LINK_URL';

export const FOOTER_SECOND_PART_TEXT = 'FOOTER_SECOND_PART_TEXT';
export const FOOTER_SECOND_LINK_URL = 'FOOTER_SECOND_LINK_URL';
export const FOOTER_SECOND_LINK_TEXT = 'FOOTER_SECOND_LINK_TEXT';

export const FOOTER_THIRD_LINK_TEXT = 'FOOTER_THIRD_LINK_TEXT';
export const FOOTER_THIRD_LINK_URL = 'FOOTER_THIRD_LINK_URL';
export const FOOTER_THIRD_PART_TEXT = 'FOOTER_THIRD_PART_TEXT';

export const FOOTER_FOURTH_LINK_TEXT = 'FOOTER_FOURTH_LINK_TEXT';
export const FOOTER_FOURTH_LINK_URL = 'FOOTER_FOURTH_LINK_URL';
export const FOOTER_FOURTH_PART_TEXT = 'FOOTER_FOURTH_PART_TEXT';

export const FOOTER_FIFTH_LINK_TEXT = 'FOOTER_FIFTH_LINK_TEXT';
export const FOOTER_FIFTH_LINK_URL = 'FOOTER_FIFTH_LINK_URL';
export const FOOTER_FIFTH_PART_TEXT = 'FOOTER_FIFTH_PART_TEXT';

export const FOOTER_SIXTH_PART_TEXT = 'FOOTER_SIXTH_PART_TEXT';
export const FOOTER_SIXTH_LINK_URL = 'FOOTER_SIXTH_LINK_URL';
export const FOOTER_SIXTH_LINK_TEXT = 'FOOTER_SIXTH_LINK_TEXT';

export const FOOTER_PAYMENTS_TAB_TEXT = 'FOOTER_PAYMENTS_TAB_TEXT';
export const FOOTER_PAYMENTS_VERIFICATION_TEXT = 'FOOTER_PAYMENTS_VERIFICATION_TEXT';
export const FOOTER_SPELINSPEKTIONEN_URL = 'FOOTER_SPELINSPEKTIONEN_URL';
export const FOOTER_LEGAL_LINK = 'FOOTER_LEGAL_LINK';
export const MOBILE_GLOBAL_MENU_PROMO_URL = 'MOBILE_GLOBAL_MENU_PROMO_URL';
export const REGULATION_HEADER_AGE_LIMIT = 'REGULATION_HEADER_AGE_LIMIT';
export const LOGIN_MESSAGE_LIMITS = 'LOGIN_MESSAGE_LIMITS';
export const MOBILE_HELP_PAGE_SUBMENU_COOKIE_POLICY = 'MOBILE_HELP_PAGE_SUBMENU_COOKIE_POLICY';
export const SIDE_MENU_INFO_AFFILIATE = 'SIDE_MENU_INFO_AFFILIATE';

export const SPORTSBOOK_GAME_RULES_LABEL = 'SPORTSBOOK_GAME_RULES_LABEL';
export const SPORTSBOOK_GAME_RULES_URL = 'SPORTSBOOK_GAME_RULES_URL';

export const FAQ_LINK = 'FAQ_LINK';
export const FAQ_TITLE = 'FAQ_TITLE';

export const FOOTER_CONTENT_TNC = 'FOOTER_CONTENT_TNC';
export const URL_STODLINJEN = 'URL_STODLINJEN';
export const URL_DSWV = 'URL_DSWV';

export const LINK_TO_EXTERNAL_COOKIE_POLICY_PAGE = 'LINK_TO_EXTERNAL_COOKIE_POLICY_PAGE';
export const MENU_EXTERNAL_COOKIE_POLICY = 'MENU_EXTERNAL_COOKIE_POLICY';

export const TEXT_KEYS = [
	MOBILE_FOOTER_LEGAL,
	MOBILE_HELP_PAGE_SUBMENU_TERMS,
	MOBILE_MAIN_MENU_SPORTS,
	MOBILE_MAIN_MENU_CASINO,
	SIDE_MENU_PRIVACY_RESPONSIBLE_GAMING,
	SIDE_MENU_PRIVACY_POLICY,
	SIDE_MENU_COMPLAINT_PROCEDURE,
	SIDE_MENU_PROMOTIONS,
	RESPONSIVE_FOOTER_AFFILIATE,
	RESPONSIVE_FOOTER_TEXT,
	RESPONSIVE_FOOTER_BLOG_TEXT,
	RESPONSIVE_FOOTER_BLOG_LINK,
	P_FOOTER_PAGE_CASINO,
	P_FOOTER_PAGE_SPORTSBOOK,
	SIDE_MENU_WHY,
	MOBILE_LANDINGPAGE_AFFILIATE_LINK,
	FOOTER_TWITTER_URL,
	FOOTER_YOUTUBE_URL,
	FOOTER_FACEBOOK_URL,
	FOOTER_INSTAGRAM_URL,
	FOOTER_INSTAGRAM,
	FOOTER_FACEBOOK,
	FOOTER_TWITTER,
	FOOTER_HALLESCHER_LOGO,
	FOOTER_WEHEN_WIESBADEN,
	FOOTER_YOUTUBE,
	FOOTER_INDIA_TWITTER_URL,
	FOOTER_INDIA_TELEGRAM_URL,
	FOOTER_INDIA_FACEBOOK_URL,
	FOOTER_INDIA_INSTAGRAM_URL,
	FOOTER_FIRST_PART_TEXT,
	FOOTER_FIRST_LINK_TEXT,
	FOOTER_FIRST_LINK_URL,
	FOOTER_SECOND_PART_TEXT,
	FOOTER_SECOND_LINK_URL,
	FOOTER_SECOND_LINK_TEXT,
	FOOTER_THIRD_LINK_URL,
	FOOTER_THIRD_LINK_TEXT,
	FOOTER_THIRD_PART_TEXT,
	FOOTER_FOURTH_LINK_URL,
	FOOTER_FOURTH_LINK_TEXT,
	FOOTER_FOURTH_PART_TEXT,
	FOOTER_FIFTH_LINK_URL,
	FOOTER_FIFTH_LINK_TEXT,
	FOOTER_FIFTH_PART_TEXT,
	FOOTER_SIXTH_PART_TEXT,
	FOOTER_SIXTH_LINK_URL,
	FOOTER_SIXTH_LINK_TEXT,
	FOOTER_PAYMENTS_TAB_TEXT,
	FOOTER_PAYMENTS_VERIFICATION_TEXT,
	FOOTER_SPELINSPEKTIONEN_URL,
	FOOTER_LEGAL_LINK,
	MOBILE_GLOBAL_MENU_PROMO_URL,
	MOBILE_HELP_PAGE_SUBMENU_COOKIE_POLICY,
	MOBILE_HELP_PAGE_SUBHEADER_ABOUT,
	SIDE_MENU_INFO_AFFILIATE,
	FAQ_LINK,
	FAQ_TITLE,
	SPORTSBOOK_GAME_RULES_URL,
	SPORTSBOOK_GAME_RULES_LABEL,
	FOOTER_CONTENT_TNC,
	URL_STODLINJEN,
	URL_DSWV,
	LINK_TO_EXTERNAL_COOKIE_POLICY_PAGE,
	MENU_EXTERNAL_COOKIE_POLICY
];
